import { combineReducers } from "@reduxjs/toolkit";

import UserVerifyReducer from "../redux/VerifyLogin";
import GlobalReducer from "../redux/GlobalSlice";

export default combineReducers({
    checkuserlogin:UserVerifyReducer,
    globalstate:GlobalReducer
})